import React from 'react';
import { ImageFile } from '~/data/types/images';

const ConversationGrayIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.417969"
        width="27.791"
        height="27.791"
        rx="13.8955"
        fill="#F5F8F9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6166 18.1978C16.7568 20.0578 14.0029 20.4596 11.7493 19.4174C11.4166 19.2834 11.1438 19.1752 10.8845 19.1752C10.1623 19.1795 9.26325 19.8798 8.79601 19.4131C8.32877 18.9458 9.02963 18.0461 9.02963 17.3195C9.02963 17.0602 8.92566 16.7923 8.79173 16.4589C7.74901 14.2056 8.15142 11.4508 10.0112 9.59146C12.3853 7.21648 16.2425 7.21648 18.6166 9.59085C20.995 11.9695 20.9907 15.8234 18.6166 18.1978Z"
        stroke="#262626"
        stroke-width="1.09537"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.7107 14.1468H16.7162"
        stroke="#262626"
        stroke-width="1.46049"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.271 14.1468H14.2765"
        stroke="#262626"
        stroke-width="1.46049"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8314 14.1468H11.8369"
        stroke="#262626"
        stroke-width="1.46049"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Component>
  );
};

export default ConversationGrayIcon;
